import IconBase from "./IconBase";

const EditIcon = (props) => (
    <IconBase {...props}>
        <path d="M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4Z" />
        <path d="M14.5 6.5l3 3" />
    </IconBase>
);

export default EditIcon;
